import React, {useState, useEffect} from 'react';
import { Language } from 'language';

const NoInternetConnection = (props) => {
    // state variable holds the state of the internet connection
    const [isOnline, setOnline] = useState(true);

    // On initization set the isOnline state.
    useEffect(()=>{
        setOnline(navigator.onLine)
    },[])

    // event listeners to update the state 
    window.addEventListener('online', () => {
        setOnline(true)
    });

    window.addEventListener('offline', () => {
        setOnline(false)
    });

    // if user is online, return the child component else return a custom component
    if(isOnline){
    return(
        props.children
    )
    } else {
        return (
			<h4 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
				{Language.message.no_internet_wrapper}
			</h4>
		);
    }
}

export default NoInternetConnection;